import styled from 'styled-components'
import React from 'react'
import { Range, getTrackBackground } from 'react-range'

const RangeBox = styled.div`
  display: flex;
`

const RangeThumb = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: #342152;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    width: 12px;
    height: 12px;
    top: 6px;
    left: 6px;
    background-color: #a1ff68;
    border-radius: 50%;
  }
`

const GenericRange = ({
  allSteps,
  onChange,
  startStep,
  minStep,
  maxStep,
  showOutput,
}) => {
  return (
    <RangeBox
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
      }}
    >
      <Range
        values={allSteps}
        step={startStep}
        min={minStep}
        max={maxStep}
        onChange={(values) => onChange(values)}
        renderTrack={({ props, children }) => (
          <div
            onMouseDown={props.onMouseDown}
            onTouchStart={props.onTouchStart}
            style={{
              ...props.style,
              height: '36px',
              display: 'flex',
              width: '100%',
            }}
          >
            <div
              ref={props.ref}
              style={{
                height: '5px',
                width: '100%',
                borderRadius: '4px',
                background: getTrackBackground({
                  values: allSteps,
                  colors: ['#342152', '#342152'],
                  min: minStep,
                  max: maxStep,
                }),
                alignSelf: 'center',
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <RangeThumb
            {...props}
            // style={{
            //   ...props.style,
            //   height: '42px',
            //   width: '42px',
            //   borderRadius: '4px',
            //   backgroundColor: '#FFF',
            //   display: 'flex',
            //   justifyContent: 'center',
            //   alignItems: 'center',
            //   boxShadow: '0px 2px 6px #AAA',
            // }}
          >
            {/* <div
            // style={{
            //   height: '16px',
            //   width: '5px',
            //   backgroundColor: isDragged ? '#548BF4' : '#CCC',
            // }}
            /> */}
          </RangeThumb>
        )}
      />
      {showOutput && (
        <output style={{ marginTop: '30px' }} id="output">
          {allSteps && allSteps[0]}
        </output>
      )}
    </RangeBox>
  )
}

export default GenericRange
